import React, { Component } from 'react'

import ButtonBanner from '../Banners/ButtonBanner.js';


import ProjectComponent from './ProjectComponent';
import ExperienceComponent from './ExperienceComponent';


//takes in a title
import "./Sections.css";


import strategy_companion from "../images/experience/strategy_companion.png";
import coding_minds from "../images/experience/coding_minds.png";

import taxi_one from "../images/projects/taxi-1.png";
import taxi_two from "../images/projects/taxi-2.png";
import taxi_three from "../images/projects/taxi-3.jpg";

import chess_ai_one from "../images/projects/chess-1.png";
import chess_ai_two from "../images/projects/chess-2.png";

import cnn_one from "../images/projects/cnn-1.png";

import pooto_flight_one from "../images/projects/pooto-flight-1.png";
import pooto_flight_two from "../images/projects/pooto-flight-2.png";

import voga1 from "../images/projects/voga1.jpg";
import voga2 from "../images/projects/voga2.jpg";
import voga3 from "../images/projects/voga3.jpg";


import headshot from "../images/headshot.png";

function Section(props) {

    return (
        <div className = "section">
            <div>
                {props.top}
                <h1 className = "section-title">{props.title}</h1>
                <div className = "section-content">
                    {props.bottom}
                </div>
            </div>
        </div>
    )
}



class AboutMe extends Component
{


    componentDidMount()
    {

    }
    
    render(){

        var introduction = (
        <div className="introduction">
        I am a junior at the University of California,
        Irvine majoring in Computer Science (graduating in 2021). 
        I enjoy working with full stack technologies, machine learning, and creating things that scale. Most importantly creating things that make the world a better place.  

            
        </div>
        )

       

        var textbox = (
        <div id = "about-container">
            <div id = "about-profile-container">
                <img alt = "headshot" className = "element" id = "headshot" src = {headshot} /> 
            </div>

            <div id = "about-container-introduction">{introduction}</div>
        </div>
        )

        return(
            <div id = "about"> 
                <Section  
                bottom = {textbox}/>
            </div>
        )
    }
}


class Projects extends Component
{
    constructor(props)
    {
        super(props);
        this.state = {
            projects : [
                {
                    img : [taxi_one, taxi_two, taxi_three],
                    description : "Taxi.IO is a web based game that players connect through mobile controllers. The Game was orignally created for UCI HACKS but then later recreated with react.js and webpack into a more deployable version. The project won the Best Game Hack Award during UCI HACKS.",
                    title: "Taxi.IO", 
                    tech: ["Webpack", "Node.js", "React.js", "JavaScript", "html", "css"],
                    github: "https://github.com/TropicalSunshine/Taxi-Mayhem-Racing",
                    devpost: "https://devpost.com/software/mayhem-taxi-racing",
                    live: null,
                    hold: false
                },
                {
                    img : [chess_ai_one, chess_ai_two],
                    description : "Using the minimax tree architecture, the algorithm analyzes all possible player moves n steps ahead. AS well as beta-alpha node pruning to enhance performance.",
                    title: "Chess AI",
                    tech: ["html", "javascript", "css"],
                    github: "",
                    devpost: null,
                    live: "https://tropicalsunshine.github.io/Chess-Ai-minimax-Implementation/",
                    hold: false
                },
                {
                    img : [cnn_one],
                    description : "Convolutional neural network, built using vanilla python. Training data taken from the MNIST hand written numbers database",
                    title: "Image Recognition Network",
                    tech: ["Python3"],
                    github: "",
                    devpost: null,
                    live: null,
                    hold: false
                },
                {
                    img: [pooto_flight_one, pooto_flight_two],
                    description: "Pooto Flight Data uses an live api to retrieve current live data arround the globe. Countries can be search to view flight data within that countries. Data visualization practice. ",
                    title: "Pooto Flight Data",
                    tech: ["JavaScript", "node.js", "react.js", "MS Fabric UI", "MapBoxGL"],
                    github: "https://github.com/TropicalSunshine/Pooto-Flight-Data",
                    live: null,
                    hold: false
                },
                {
                    img: [voga1, voga2, voga3],
                    description: "Voga provides a solution to those people who want to learn a new language but are intimidated by the language barrier. Voga allows people to use their device's camera to capture objects that they want to know in the foreign language. Simply point the camera to an object that you wish to know the foreign language of and Voga will save the word as a flashcard so the user could look back on later.",
                    title: "Voga (Vocabulary Gallery)",
                    tech: ["JavaScript", "Node.js", "React.js", "FireBase", "TensorFlow", "Google Cloud API", "AWS"],
                    devpost: "https://devpost.com/software/voga",
                    hold: false
                },
                {
                    img: null,
                    description: null,
                    title: null,
                    tech: null,
                    devpost: null,
                    hold: true
                }
            ]
        }
    }


    render(){
        var project_columns = [];

        this.state.projects.forEach((element, index) => {
                
                if((index + 1) % 3 === 0){
                    project_columns.push([this.state.projects[index - 2], this.state.projects[index - 1], this.state.projects[index]]);
                };
        });

        
        var project_list = project_columns.map( (project, index) => {
                return (
                    <div className = "project-column">
                        <ProjectComponent
                            img = {project[0].img}
                            title = {project[0].title}
                            tech = {project[0].tech}
                            github = {project[0].github}
                            desc = {project[0].description}
                            devpost = {project[0].devpost}
                            live = {project[0].live}
                            key = {"project_component_" + (index).toString()}
                            hold = {project[0].hold}/>
                         <ProjectComponent
                            img = {project[1].img}
                            title = {project[1].title}
                            tech = {project[1].tech}
                            github = {project[1].github}
                            desc = {project[1].description}
                            devpost = {project[1].devpost}
                            live = {project[1].live}
                            key = {"project_component_" + (index + 1).toString()}
                            hold = {project[1].hold}/>
                        <ProjectComponent
                            img = {project[2].img}
                            title = {project[2].title}
                            tech = {project[2].tech}
                            github = {project[2].github}
                            desc = {project[2].description}
                            devpost = {project[2].devpost}
                            live = {project[2].live}
                            key = {"project_component_" + (index + 2).toString()}
                            hold = {project[2].hold}/>
                    </div>
                )
            }
         );

        return(
            <div id = "projects">
                <div className = "project-content">
                    {project_list}
                </div> 
            </div>
        )
    }
}


class Context extends Component
{
    constructor(props)
    {
        super(props)
        this.state = {
            showAbout: true,
            showProjects: false,
            showExperience: false
        }

        this.handleButtonBanner = this.handleButtonBanner.bind(this);
    }


    handleButtonBanner(buttonIndex,i){
        if(buttonIndex === 1){
            this.setState({
                showAbout: true,
                showProjects: false,
                showExperience: false
            })
        } else if(buttonIndex === 2){
            this.setState({
                showAbout: false,
                showProjects: false,
                showExperience: true
            })
        } else if(buttonIndex === 3){
            this.setState({
                showAbout: false,
                showProjects: true,
                showExperience: false
            })
        } 
    }

    render(){

        var title = (
            <h1 id = "about-title">
                <span id = "about-title-1">Hello,</span>
                <span id = "about-title-2"> I'm </span>
                <span id = "about-title-3">Jason</span>
            </h1>
        )

        var exp = (
            <ExperienceComponent
                experiences = {[
                    {
                        img: coding_minds,
                        link: "https://codingmindsacademy.com/",
                        company: "Coding Minds",
                        duration: "Full Stack Intern Feburary 2020 - Current"
                    },
                    {
                        link: "http://strategycompanion.com/",
                        img: strategy_companion,
                        company: "Strategy Companion",
                        duration: "Software Engineer  March 2019 - September 2019",
                        resp: "At Strategy Companion I was in charge of implmenting front-end data visualization chart components as well as building the UI framework. \
                        The UI framework enhanced company software into a more modernized design.\
                        The chart compoents documented and modulized in require.js modules allowed for easy reusablility."       
                    }
                ]}
            />
        );

        return (
            <div id="Context">
                <Section
                title = {title}/>
                <div className = "context-container">
                    <ButtonBanner action = {this.handleButtonBanner}/>
                    <div className = "Content">
                        {this.state.showAbout && (
                            <div className = "content-animation-fade-in">
                                <AboutMe/>
                            </div>
                            )}
                        {this.state.showExperience && 
                            (
                                <div className = "content-animation-fade-in">
                                    {exp}
                                </div>
                            )}
                        {this.state.showProjects && (
                            <div className = "content-animation-fade-in">
                                <Projects/>
                            </div>
                        )}
                        <div>
                            <h1 style={{
                                paddingTop: "10%",
                                width: "100%",
                                textAlign: "center",
                                fontSize: "10pt",
                                color: "#333"
                            }}>© Jason Liu 2021</h1>
                        </div>
                    </div>
                </div>

            </div>
        )
    }
}

function Sections(props)
{
    return(
        <div>
            <Context/>
        </div>
    )
}

export default Sections;


